import { DeskActivity, DeskDocument } from 'client/api/backend/schemas';
import { registerToolkitObjectType } from 'client/components/toolkit/objects/registerToolkitObjectType';

export const ActivityToolkitObject =
  registerToolkitObjectType<DeskActivity>('activity');
